import { RegistriaUsersResponse } from '../../models/registria/registria-users-response.interface';
import { mockRegistriaSnippetResponse } from './registria-snippet-response.mock';

export const mockRegistriaUserResponse: RegistriaUsersResponse = {
  snippet_data: mockRegistriaSnippetResponse,
  sessionId: '1234567890',
};
